import { render, staticRenderFns } from "./ReactivateAccountExpired.vue?vue&type=template&id=68b5efca&scoped=true&"
import script from "./ReactivateAccountExpired.vue?vue&type=script&lang=js&"
export * from "./ReactivateAccountExpired.vue?vue&type=script&lang=js&"
import style0 from "./ReactivateAccountExpired.vue?vue&type=style&index=0&id=68b5efca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b5efca",
  null
  
)

export default component.exports